export default __webpack_public_path__ + "static/sh-ta-17bd97707b3d06da2277b2e456c6ea33.svg";